import React from "react";
import { Row, Col, Form, Input } from "antd";

const { TextArea } = Input;

const Malignancy = () => {
  return (
    <Row gutter={[16, 16]} className="clinical-diagnosis-notes-row">
      <Col xs={24} md={16} lg={12}>
        <Form.Item
          name="clinical_diagnosis_notes"
          label="Clinical Diagnosis"
          className="clinical-diagnosis-notes-item"
        >
          <TextArea
            rows={3}
            placeholder="Please specify"
            className="clinical-diagnosis-notes-input"
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default Malignancy;
